import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useFindFolder } from './useFindFolder';
import { useSearchFiles } from './useSearchFiles';
// combine find and search functionality
export function useFindFiles(folderId = null) {
    const folderRef = useRef();
    const [search, setSearch] = useState('');
    const folderResult = useFindFolder(folderId);
    const searchResult = useSearchFiles();
    const { data: folder, get: findFolder } = folderResult;
    const { data: searchedFiles, get: searchFiles } = searchResult;
    const isLoading = folderResult.isLoading || searchResult.isLoading;
    const error = folderResult.error || searchResult.error;
    const files = useMemo(() => {
        return (search ? searchedFiles : folder === null || folder === void 0 ? void 0 : folder.children) || [];
    }, [folder, search, searchedFiles]);
    const findFiles = useCallback((dto = {}) => {
        const { search } = dto;
        setSearch(search || '');
        if (search) {
            searchFiles(dto);
        }
        // also get folder if not yet fetched
        if (!folderRef.current || !search) {
            findFolder(dto);
        }
    }, [findFolder, searchFiles]);
    useEffect(() => {
        folderRef.current = folder;
    }, [folder]);
    return { files, folder, isLoading, error, findFiles };
}
//# sourceMappingURL=useFindFiles.js.map